import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { GetMoreRoutingModule } from './get-more-routing.module';
import { GetMoreListComponent } from './get-more-list/get-more-list.component';
import { GetMoreCreateComponent } from './get-more-create/get-more-create.component';

@NgModule({
  declarations: [GetMoreListComponent, GetMoreCreateComponent],
  imports: [
    CommonModule,
    GetMoreRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class GetMoreModule { }
